import "./Modal.scss";
import React, { useState, useMemo, useCallback, useEffect, useRef } from "react";

import Pagination from "../Pagination";

import axios from 'util/axios';
import {useDispatch, useSelector} from "react-redux";
import { useDidMountEffect } from "util";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";

import { DownloadFile, LPAD } from "util";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { IoCloseSharp } from "react-icons/io5";

const Modal = ({ onClose, children }) => {
    const HandleClose = (e) => {
        if (e.keyCode === 27 || e.keyCode === 13) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };
    window.addEventListener("keyup", HandleClose);
    const { t } = useTranslation(["page"]);
    return (
        <div className="pop">
            <div className="pop_box">
                <div className="top">
                    <div className="close" onClick={onClose}>
                        <div className="cc c1"></div>
                        <div className="cc c2"></div>
                    </div>
                </div>

                <div className="middle">{children}</div>
                <div className="bottom">
                    <div className="btn_box">
                        <div className="btn" onClick={onClose}>
                            {t("close")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Confirm = ({ onClose, autoComplete = true, children, onConfirm, valid = () => true, overflow = "" }) => {
    const { t } = useTranslation(["page"]);
    const HandleConfirm = (e) => {
        if (e.keyCode === 13 && e.target.tagName.toUpperCase() !== "TEXTAREA") {
            _confirm();
        } else if (e.target.tagName.toUpperCase() === "TEXTAREA") {
            window.removeEventListener("keyup", HandleConfirm);
        }
    };
    const HandleClose = (e) => {
        if (e.keyCode === 27) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };

    if (autoComplete) {
        window.addEventListener("keyup", HandleConfirm);
        window.addEventListener("keyup", HandleClose);
    }
    const _confirm = () => {
        if (valid()) {
            window.removeEventListener("keyup", HandleConfirm);
            onClose();
            onConfirm();
        }
    };

    return (
        <div className="pop">
            <div className={`pop_box confirm ${overflow}`} >
                <div className="top">
                    <div className="close" onClick={onClose}>
                        <div className="cc c1"></div>
                        <div className="cc c2"></div>
                    </div>
                </div>
                <div className="middle">{children}</div>

                <div className="bottom">
                    <div className="btn_box">
                        <div className="btn" onClick={_confirm}>
                            {t("confirm")}
                        </div>
                        <div className="btn n" onClick={onClose}>
                            {t("cancle")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ConfirmWithMessage = ({
    onClose,
    autoComplete = true,
    message = "Message",
    invalidMessage = "ERRFront001",
    onConfirm,
    children
}) => {
    const { t } = useTranslation(["page"]);

    const [ConfirmMessage, SetConfirmMessage] = useState("");
    const [ExceptionMessage, SetExceptionMessage] = useState(false);
    const HandleKeyBind = (e) => {
        if (
            e.target.tagName.toUpperCase() !== "TEXTAREA" ||
            e.target.tagName.toUpperCase() !== "INPUT"
        ) {
            if (e.keyCode === 13) {
                _confirm();
            }
            if (e.keyCode === 27) {
                onClose();
            }
        }
    };
    useEffect(() => {
        if (autoComplete) {
            document.addEventListener("keyup", HandleKeyBind);
        }
        return () => {
            document.removeEventListener("keyup", HandleKeyBind);
        };
    }, []);
    const _confirm = () => {
        if (ConfirmMessage) {
            onClose();
            onConfirm(ConfirmMessage);
        } else {
            SetExceptionMessage(true);
        }
    };

    return (
        <div className="bpl-modal">
            <div className="bpl-modal-inner confirm with-message">
                <div className="header">
                    <div className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </div>
                </div>
                <div className="main">
                    {children && children}
                    <p>{message} : </p>
                    <div className={"textarea"}>
                        <textarea
                            value={ConfirmMessage}
                            onChange={(e) => SetConfirmMessage(e.target.value)}
                            onFocus={() => SetExceptionMessage(false)}
                        />
                    </div>
                    {ExceptionMessage && (
                        <span className={"exception invalid"}>{t(invalidMessage)}</span>
                    )}
                </div>

                <div className="footer">
                    <button className="bpl-btn filled success" onClick={_confirm}>
                        {t("confirm")}
                    </button>
                    <button className="bpl-btn filled danger" onClick={onClose}>
                        {t("cancle")}
                    </button>
                </div>
            </div>
        </div>
    );
};

const Rev = ({ onClose, data }) => {
    const { t } = useTranslation(["page"]);
    const PAGE_VIEW = 10;
    const [Page, SetPage] = useState(1);
    const [revChild, setRevChild] = useState([]);

    const HandleClose = (e) => {
        if (e.keyCode === 27 || e.keyCode === 13) {
            onClose();
            window.removeEventListener("keyup", HandleClose);
        }
    };
    window.addEventListener("keyup", HandleClose);
    const dispatch = useDispatch();

    const getRevList = useCallback(async () => {
        dispatch({ type: "LOADING_ON" });
        const response = await axios
            .post(process.env.REACT_APP_API + "/pcsCreate/retrieveSheetRevisionList", {
                sheetcd: data,
                curPage: Page,
                boardView: PAGE_VIEW,
            })
            .then((Response) => Response.data.data);
        dispatch({ type: "LOADING_OFF" });
        setRevChild(response);
    }, [dispatch, data, Page]);

    useEffect(() => {
        getRevList();
    }, [getRevList]);



    const renderRevChild = useMemo(() => {
        return revChild?.result?.map(({ revision, userNm, createDt }, i) => (
            <tr key={"revModal" + i}>
                <td>{revision}</td>
                <td>{userNm}</td>
                <td>{createDt}</td>
            </tr>
        ));
    }, [revChild]);

    return (
        <div className="pop rev">
            <div className="pop_box">
                <div className="top">
                    <div className="close" onClick={onClose} aria-hidden="true">
                        <div className="cc c1"></div>
                        <div className="cc c2"></div>
                    </div>
                </div>

                <div className="bottom">
                    <div className="rev_box">
                        <div className={'rev_box_tbl'}>
                            <table>
                                <colgroup>
                                    <col width="80px" />
                                    <col width="180px" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>Revision</th>
                                        <th>Owner</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>{renderRevChild}</tbody>
                            </table>
                        </div>
                        {/* <Pagination onClick={(i) => SetPage(i)} data={revChild?.boardPager} /> */}

                        <div className="c_btn" onClick={onClose} aria-hidden="true">
                            {t("close")}
                        </div>
                        <Link to={"/diffData"} state={data} className="diff_btn">
                            {t("revCompare")}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RevLog = ({ onClose, data }) => {
    const { t } = useTranslation(["page"]);
    const [RenderItem, SetRenderItem] = useState(null);
    const HandleClose = (e) => {
        if (e.keyCode === 27 || e.keyCode === 13) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };
    window.addEventListener("keyup", HandleClose);
    const dispatch = useDispatch();
    const getData = useCallback(async () => {
        dispatch({ type: "LOADING_ON" });
        const response = await axios
            .post(process.env.REACT_APP_API + "/pcsCreate/retrieveSheetRevisionLog", data)
            .then((Response) => Response.data.data);
        SetRenderItem(response);
        dispatch({ type: "LOADING_OFF" });
    }, [data, dispatch]);
    useEffect(() => {
        getData();
    }, [data, getData]);
    const renderData = useMemo(() => {
        const fileList = RenderItem?.fileDataList;
        return (
            <>
                <tbody>
                    <tr>
                        <td>Rev.{RenderItem?.result?.revision}</td>
                        <td>{RenderItem?.result?.userNm}</td>
                        <td style={{ fontSize: "14px" }}>{RenderItem?.result?.createDt}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="3" className={"RevLogTextarea"}>
                            <div>
                                <div className={"textareaDiv"}>
                                    {RenderItem?.result?.revisionLog}
                                </div>
                                {fileList?.length > 0 && (
                                    <ul>
                                        {fileList.map((f, i) => {
                                            return (
                                                <li
                                                    key={"revfile" + i}
                                                    onClick={() => {
                                                        DownloadFile({
                                                            api: "/pcsCreate/downloadFile",
                                                            body: {
                                                                name: f.orgFileName,
                                                                sheetcd: f.code,
                                                                revision:
                                                                    RenderItem?.result?.revision,
                                                            },
                                                            name: f.orgFileName,
                                                        });
                                                    }}
                                                >
                                                    {f?.orgFileName}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </>
        );
    }, [RenderItem]);
    return (
        <div className="pop rev">
            <div className="pop_box">
                <div className="top">
                    <div className="close" onClick={onClose}>
                        <div className="cc c1"></div>
                        <div className="cc c2"></div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="rev_box">
                        <table>
                            <thead>
                                <tr>
                                    <th>Revision</th>
                                    <th>Owner</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            {renderData}
                            {/* <tbody>
								<tr>
									<td>Rev.{data.revision}</td>
									<td>{data.userNm}</td>
									<td style={{ fontSize: "14px" }}>{data.createDt}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colSpan="3">
										<textarea className={"RevLogTextarea"} rows="25" defaultValue={data.revisionLog} readOnly />
									</td>
								</tr>
							</tfoot> */}
                        </table>
                        <div className="c_btn" onClick={onClose}>
                            {t("close")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const FileUpload = ({ onClose, fileInfo }) => {
    const { t } = useTranslation(["page"]);
    const [FileInput, SetFileInput] = useState(null);
    const HandleClose = (e) => {
        if (e.keyCode === 27) {
            window.removeEventListener("keyup", HandleClose);
            onClose(false, FileInputRef);
        } else if (e.keyCode === 13) {
            window.removeEventListener("keyup", HandleClose);
            onClose(true, FileInputRef);
        }
    };

    const FileInputRef = useRef();

    const FileClick = () => {
        FileInputRef.current.click();
    };

    useEffect(() => {
        // FileInputRef.current.files = fileInfo.current.files
        SetFileInput(fileInfo);
    }, []);

    const fileControl = async () => {
        let f;
        let fileHref;
        let name;
        if (FileInputRef.current.files.length > 0) {
            f = FileInputRef.current.files[0];
            name = f.name;
            fileHref = window.URL.createObjectURL(f);
        } else if (FileInput.files.current.files.length > 0) {
            f = FileInput.files.current.files[0];
            name = f.name;
            fileHref = window.URL.createObjectURL(f);
        } else {
            const response = await axios({
                url: process.env.REACT_APP_API + "/pcsCreate/downloadFile",
                data: {
                    name: FileInput.name,
                    sheetcd: FileInput.sheetCd,
                    revision: FileInput.revision,
                },
                method: "POST",
                responseType: "blob",
            });
            name = FileInput.name;
            fileHref = new Blob([response.data]);
        }

        const link = document.createElement("a");
        link.href = fileHref;
        link.style.display = "none";

        link.download = name;

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(fileHref);
    };
    const fileDelete = () => {
        FileInputRef.current.value = "";
        SetFileInput(null);
    };

    window.addEventListener("keyup", HandleClose);

    const renderBtn = useMemo(() => {
        if (!!FileInput)
            return (
                <>
                    <div className="isFile" onClick={fileControl}>
                        {FileInput.name}
                    </div>
                    <span onClick={fileDelete}>X</span>
                </>
            );
        else
            return (
                <div className="sec" onClick={FileClick}>
                    {t("fileSelect")}
                </div>
            );
    }, [FileInput]);

    return (
        <div className="pop upload">
            <div className="pop_box">
                <div className="top">
                    <div className="close" onClick={() => onClose(false, FileInputRef)}>
                        <div className="cc c1"></div>
                        <div className="cc c2"></div>
                    </div>
                </div>
                <div className="middle">
                    <div className="file">
                        <div className="select">
                            <div className="left">File</div>
                            <div className="right">
                                {renderBtn}
                                <div style={{ display: "none" }}>
                                    <input
                                        type="file"
                                        ref={FileInputRef}
                                        onChange={(e) => {
                                            SetFileInput({
                                                name: e.target.files[0].name,
                                                files: e.target.files,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottom">
                    <div className="btn_box">
                        <div className="btn" onClick={() => onClose(true, FileInputRef)}>
                            {t("upload")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SessionModal = ({ onClose, onConfirm, timeover }) => {
    const { t } = useTranslation(['page']);
    const [timeout, setTimeout] = useState(process.env.REACT_APP_SESSION_TMOUT);
    const tmoutRef = useRef(null);

    tmoutRef.current && clearInterval(tmoutRef.current);

    tmoutRef.current = setInterval(() => {
        if (timeout > 0) {
            setTimeout(OLD => OLD - 1);
        } else {
            clearInterval(tmoutRef.current);
        }
    }, 1000)



    return (
        <div className="pop">
            <div className={`pop_box confirm`} >
                <div className="top">
                    {/* <div className="close" onClick={onClose}>
                        <div className="cc c1"></div>
                        <div className="cc c2"></div>
                    </div> */}
                </div>
                <div className="middle">
                    <p>{t("sessionTimeout")}</p>
                    <p className={`text-center`}>00:{LPAD(timeout, 2, '0')}</p>
                </div>

                <div className="bottom">
                    <div className="btn_box">
                        <div className="btn" onClick={onConfirm}>
                            {t("extension")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const Confirm2Modal = ({ onClose, autoComplete = true, children, onConfirm, valid = () => true, overflow = "" }) => {

    const tdSelector = useSelector((store) => store.tdSelector);
    const { t } = useTranslation(["page"]);
    const HandleConfirm = (e) => {
        if (e.keyCode === 13 && e.target.tagName.toUpperCase() !== "TEXTAREA") {
            _confirm();
        } else if (e.target.tagName.toUpperCase() === "TEXTAREA") {
            window.removeEventListener("keyup", HandleConfirm);
        }
    };
    const HandleClose = (e) => {
        if (e.keyCode === 27) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };

    if (autoComplete) {
        window.addEventListener("keyup", HandleConfirm);
        window.addEventListener("keyup", HandleClose);
    }
    const _confirm = () => {
        if (valid()) {
            window.removeEventListener("keyup", HandleConfirm);
            onClose();
            onConfirm();
        }
    };

    const canMove = useRef(true);
    const saved = useRef();
    const MO = (e) => {
        if (!!tdSelector.td) {
            saved.current = tdSelector.td;
        }
        if (e.type === "mousedown") {
        }
        canMove.current = false;
    };

    const ML = () => {
        canMove.current = true;
    };

    return (

            <div className="pop pop2">
                <Draggable
                    onStart={() => {
                        return canMove.current;
                    }}
                >

                <div className={`pop_box confirm ${overflow}`} style={{top:"5%",left:"5%"}}>
                    <div className="top"style={{cursor: "all-scroll"}}>
                        <div className="close" onClick={onClose}>
                            <div className="cc c1"></div>
                            <div className="cc c2"></div>
                        </div>
                    </div>
                    <div className="middle remark-pop" onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO}>
                        {children}
                    </div>

                    <div className="bottom"  onMouseOver={MO} onMouseLeave={ML} onMouseDown={MO}>
                        <div className="btn_box">
                            <div className="btn" onClick={_confirm}>
                                {t("confirm")}
                            </div>
                            <div className="btn n" onClick={onClose}>
                                {t("cancle")}
                            </div>
                        </div>
                    </div>
                </div>
                </Draggable>
            </div>

    );
};

const ConfirmIndexDB = ({ onClose, autoComplete = true, children, onConfirm, valid = () => true, overflow = "" }) => {
    const { t } = useTranslation(["page"]);
    const HandleConfirm = (e) => {
        if (e.keyCode === 13 && e.target.tagName.toUpperCase() !== "TEXTAREA") {
            _confirm();
        } else if (e.target.tagName.toUpperCase() === "TEXTAREA") {
            window.removeEventListener("keyup", HandleConfirm);
        }
    };
    const HandleClose = (e) => {
        if (e.keyCode === 27) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };

    if (autoComplete) {
        window.addEventListener("keyup", HandleConfirm);
        window.addEventListener("keyup", HandleClose);
    }
    const _confirm = () => {
        if (valid()) {
            window.removeEventListener("keyup", HandleConfirm);
            onConfirm();
            onClose();
        }
    };

    return (
        <div className="pop">
            <div className={`pop_box confirm ${overflow}`} >
                <div className="top">
                    {/*<div className="close" onClick={onClose}>*/}
                    {/*    <div className="cc c1"></div>*/}
                    {/*    <div className="cc c2"></div>*/}
                    {/*</div>*/}
                </div>
                <div className="middle">{children}</div>

                <div className="bottom">
                    <div className="btn_box">
                        <div className="btn" onClick={_confirm}>
                            {t("confirm")}
                        </div>
                        <div className="btn n" onClick={onClose}>
                            {t("cancle")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { Modal, Confirm, ConfirmWithMessage, Rev, RevLog, FileUpload, SessionModal,Confirm2Modal,ConfirmIndexDB };
